/// <reference path="../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// "Restart secure session" banner (iOS `ConversationView` repair banner parity).
// Shown when a conversation is STRANDED — it missed an MLS Commit and can't
// advance its epoch, so new messages can neither send nor decrypt. The host
// supplies `onRestart` (re-establish the secure session) + `busy`. Purely
// presentational; className-first.

import type React from 'react';
import { Pressable, Text, View } from 'react-native';
import { ShieldAlert } from 'lucide-react-native';

export interface StrandedRepairBannerProps {
  readonly onRestart: () => void;
  readonly busy?: boolean | undefined;
}

export const StrandedRepairBanner: React.FC<StrandedRepairBannerProps> = ({ onRestart, busy = false }) => (
  <View className="mx-sm my-1 flex-row items-center gap-3 rounded-xl border border-[#E5484D]/40 bg-[#E5484D]/10 px-3 py-2.5">
    <ShieldAlert size={18} strokeWidth={2} color="#E5484D" />
    <View className="flex-1">
      <Text className="text-[13px] font-semibold text-light-text-primary dark:text-[#F5F6F8]">
        This chat's secure session needs repair
      </Text>
      <Text className="text-[12px] text-light-text-secondary dark:text-white/70">
        Messages can't be sent or read until you restart the secure session.
      </Text>
    </View>
    <Pressable
      accessibilityRole="button"
      accessibilityLabel="Restart secure session"
      onPress={busy ? undefined : onRestart}
      disabled={busy}
      className={`rounded-full bg-[#E5484D] px-3 py-1.5 ${busy ? 'opacity-60' : 'active:opacity-80'}`}
    >
      <Text className="text-[12px] font-semibold text-white">
        {busy ? 'Restarting…' : 'Restart secure session'}
      </Text>
    </Pressable>
  </View>
);
